<template>
  <div id="footer">
    <div class="left">版权所有 © 某股份科技有限公司 2020-2021</div>
    <div class="right">ICP证1211号 京ICP备1132883号-1</div>
  </div>
</template>

<script>
export default {
  name: 'footer',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
#footer
  height: 50px
  font-size:12px;
  color:hsla(0,0%,100%,0.5);
  line-height: 50px;
  padding 0 50px
  background-color:#4A81C0
  display flex
  .left
    flex 1
    text-align left
  .right
    flex 1
    text-align right
</style>



// WEBPACK FOOTER //
// src/components/footer.vue